<template>
    <div id="dropCheckBox">
        <div>
            <Input v-model="checkedValue" style="cursor: pointer;" readonly :placeholder="placeholder" :icon="icon" @on-focus="focus" @on-click="bindTag"></Input>
        </div>
        <div class="customerSelect" v-show="showDropSelect">
            <div class="checkAll">
                <Checkbox
                style="
                display:block;
                display:block;
                height:32px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;" 
                :indeterminate="indeterminate"
                :value="checkAll"
                @click.prevent.native="handleCheckAll">全部</Checkbox>
            </div>
            <CheckboxGroup v-model="currenCheckAllGroup" @on-change="checkAllGroupChange">
                <Checkbox 
                style="
                display:block;
                display:block;
                height:32px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;"  
                v-for="item in checkboxData" 
                :label="item.id" 
                :key="item.id">
                    {{item.name}}
                </Checkbox>
            </CheckboxGroup>
        </div>
    </div>
</template>
<script>
export default {
    name:"dropCheckBox",
    props:['checkboxData','placeholder','type','checkedValue','checkAllGroup'],
    data(){
        return{
            icon:"ios-arrow-down",
            showDropSelect:false,
            indeterminate: this.checkAllGroup.length > 0 && this.checkAllGroup.length != this.checkboxData.length ? true : false,
            checkAll: false,
        }
    },
    computed: {
        currenCheckAllGroup: {
            // getter
            get: function () {
                return this.checkAllGroup
            },
            // setter
            set: function (newValue) {
            }
        }
    },
    mounted (){
        let _this = this;
        document.addEventListener('click',function(e){
            var e = e || window.event; //浏览器兼容性
            var elem = e.target || e.srcElement;
            while (elem) { //循环判断至跟节点，防止点击的是div子元素
                if (elem.id && elem.id=='dropCheckBox') {
                    return;
                }
                elem = elem.parentNode;
            }
            _this.showDropSelect = false
            _this.icon = 'ios-arrow-down'
        })
    },
    methods:{
        //输入框获取焦点，控制图表的方向和下拉菜单的显示隐藏
        focus(){
            this.showDropSelect = true
            this.icon = 'ios-arrow-up'
        },
        //监听选择下拉图表，控制图表的方向和下拉菜单的显示隐藏
        bindTag(){
            if(this.showDropSelect){
                this.showDropSelect = false
                this.icon = 'ios-arrow-down'
            }else{
                this.showDropSelect = true
                this.icon = 'ios-arrow-up'
            }
        },
        //监听全选反选
        handleCheckAll () {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;
            let arr = []
            let name = []
            for(let item of this.checkboxData){
                arr.push(item.id)
                name.push(item.name)
            }
            if (this.checkAll) {
                this.setData(arr,name.join(','))
            } else {
                this.setData([],'')
            }
        },
        //监听选择列表
        checkAllGroupChange (data) {
            let name = []
            for(let item of this.checkboxData){
                for(let v of data){
                    if(v == item.id){
                        name.push(item.name)
                    }
                }
            }
            this.setData(data,name.join(','))
            if (data.length == this.checkboxData.length) {
                this.indeterminate = false;
                this.checkAll = true;
            }else if (data.length > 0 && data.length != this.checkboxData.length) {
                this.indeterminate = true;
                this.checkAll = false;
            }else{
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        //判断不同的组件
        setData(data,checkedShowValue){
                //客户分组
           if(this.type == 'member_group'){
               this.$emit("member_group_even",data,checkedShowValue)
               //签单门店
           }else if(this.type == 'signStoreList'){
               this.$emit("signStoreList_even",data,checkedShowValue)
               //跟进门店
           }else if(this.type == 'followStoreList'){
               this.$emit("followStoreList_even",data,checkedShowValue)
           }else if(this.type == 'delayStoreList'){
               this.$emit("delayStoreList_even",data,checkedShowValue)
           }
        }
    },
    watch:{
        //监听选择变化，对全选按钮的样式控制
        currenCheckAllGroup(val){
            if(val.length == 0){
                this.indeterminate = false
                this.checkAll = false;
            }else if(this.checkAllGroup.length > 0 && this.checkAllGroup.length != this.checkboxData.length){
                this.indeterminate = true
                this.checkAll = false;
            }else if(this.checkAllGroup.length == this.checkboxData.length){
                this.indeterminate = false
                this.checkAll = true;
            }
        }
            
    }
}
</script>
<style lang="" scoped>
    .checkAll{
        border-bottom: 1px solid #e9e9e9;
        display:flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
    }
    .customerSelect{
        width: 100%;
        position: absolute;
        top: 33px;
        left:0;
        max-height: 200px;
        overflow: auto;
        margin: 5px 0;
        padding: 5px;
        background-color: #fff;
        box-sizing: border-box;
        border-radius: 4px;
        box-shadow: 0 1px 6px rgba(0,0,0,.2);
        z-index: 900;
    }
</style>


// WEBPACK FOOTER //
// src/commonTmp/dropCheckBox.vue